import React from 'react'
import { Header1, Text, LinkButton } from '../../styles/Components'
import { gsColors } from '../../styles/Variables'

const HeaderContent = () => {
  return (
    <>
      <Header1
        color={gsColors.salmon}
        className="web-header-text"
        margin="0 0 24px"
      >
        Join Our<br />
        Ambassador
        <br />
        Program
      </Header1>
      <Header1 color={gsColors.salmon} className="mobile-header-text">
        Join Our<br />
        Ambassador
        <br />
        Program
      </Header1>
      <Text
        color={gsColors.white}
        weight={400}
        lineHeight="138%"
        fontSize={22}
        margin="0 0 48px"
      >
        We&apos;re actively seeking influencers, digital 
        creators, industry leaders, and 
        tastemakers to join our growing
        community of Glamsquad ambassadors.
      </Text>
      <LinkButton
        href='https://glamsquad2020.typeform.com/to/qHQNqsdf'
        target='_blank'
        large
        color={gsColors.salmon}
        style={{ color: gsColors.cobalt }}
      >
        Apply Now
      </LinkButton>
    </>
  )
}

export default HeaderContent
